// Request Constants
export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const FAILURE = '_FAILURE';

// statuses
export const INIT = 'INIT';
export const OK = 'OK';
export const ERROR = 'ERROR';
export const LOADING = 'LOADING';

export const ANONYMOUS = 'ANONYMOUS';
export const AUTHENTICATED = 'AUTHENTICATED';
export const STUDENT = 'STUDENT';

// local storage keys
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
